/**
 * KLLA Festive Diwali Interactive Effects & Scroll Parallax Engine
 * Lightweight, hardware-accelerated, 60fps animations
 */

(function () {
  'use strict';

  // 1. Scroll-Driven Parallax Engine
  function initParallax() {
    const parallaxItems = document.querySelectorAll('[data-parallax-speed]');
    if (!parallaxItems.length) return;

    let ticking = false;

    function updateParallax() {
      const scrollY = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;

      parallaxItems.forEach(function (el) {
        const rect = el.getBoundingClientRect();
        // Only compute if within or near viewport
        if (rect.top < windowHeight + 200 && rect.bottom > -200) {
          const speed = parseFloat(el.getAttribute('data-parallax-speed')) || 0.1;
          const centerY = rect.top + rect.height / 2;
          const distFromCenter = centerY - windowHeight / 2;
          const translateY = distFromCenter * speed;
          el.style.transform = 'translate3d(0, ' + translateY.toFixed(2) + 'px, 0)';
        }
      });

      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(updateParallax);
          ticking = true;
        }
      },
      { passive: true }
    );

    // Initial run
    updateParallax();
  }

  // 2. Scroll Reveal Observer
  function initScrollReveal() {
    const revealElements = document.querySelectorAll('.klla-reveal-up');
    if (!revealElements.length || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    revealElements.forEach(function (el) {
      observer.observe(el);
    });
  }

  // 3. Golden Spark Particle Burst
  window.kllaLaunchSparks = function (originX, originY) {
    const x = originX || window.innerWidth / 2;
    const y = originY || window.innerHeight / 2;
    const particleCount = 28;
    const colors = ['#FFD700', '#FFA500', '#FFECB3', '#FFF8E1', '#D4AF37'];

    const container = document.createElement('div');
    container.style.position = 'fixed';
    container.style.inset = '0';
    container.style.pointerEvents = 'none';
    container.style.zIndex = '999999';
    container.style.overflow = 'hidden';
    document.body.appendChild(container);

    for (let i = 0; i < particleCount; i++) {
      const particle = document.createElement('div');
      const size = Math.random() * 8 + 4;
      const angle = (Math.PI * 2 * i) / particleCount + (Math.random() - 0.5);
      const velocity = Math.random() * 120 + 60;
      const destX = Math.cos(angle) * velocity;
      const destY = Math.sin(angle) * velocity - 20;
      const color = colors[Math.floor(Math.random() * colors.length)];

      particle.style.position = 'absolute';
      particle.style.left = x + 'px';
      particle.style.top = y + 'px';
      particle.style.width = size + 'px';
      particle.style.height = size + 'px';
      particle.style.borderRadius = '50%';
      particle.style.backgroundColor = color;
      particle.style.boxShadow = '0 0 8px ' + color;
      particle.style.transition = 'transform 0.9s cubic-bezier(0.165, 0.84, 0.44, 1), opacity 0.9s ease';
      particle.style.transform = 'translate3d(0, 0, 0)';
      particle.style.opacity = '1';

      container.appendChild(particle);

      // Animate outwards
      setTimeout(
        (function (p, dx, dy) {
          return function () {
            p.style.transform = 'translate3d(' + dx + 'px, ' + dy + 'px, 0) scale(0.3)';
            p.style.opacity = '0';
          };
        })(particle, destX, destY),
        16
      );
    }

    // Clean up container
    setTimeout(function () {
      if (container.parentNode) {
        container.parentNode.removeChild(container);
      }
    }, 1100);
  };

  // 4. Interactive 3D Card Parallax Tilt (Desktop only)
  function initCardTilt() {
    if (!window.matchMedia('(pointer: fine)').matches) return;

    const cards = document.querySelectorAll('.product-card, .ps-card, .klla-col-card, .kgs-card');
    cards.forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        const rotateX = ((y - centerY) / centerY) * -5.5;
        const rotateY = ((x - centerX) / centerX) * 5.5;

        card.style.transform =
          'perspective(900px) rotateX(' +
          rotateX.toFixed(2) +
          'deg) rotateY(' +
          rotateY.toFixed(2) +
          'deg) translateY(-4px)';
      });

      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

  // 5. Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initParallax();
      initScrollReveal();
      initCardTilt();
    });
  } else {
    initParallax();
    initScrollReveal();
    initCardTilt();
  }
})();
